<template>
  <section>
    <Header :state="state"></Header>
    <div class="content_wrap">
      <h1>安全生产管理信息化套餐</h1>
      <ul class="ul_meal">
        <li v-for="(item,index) in listData" :key="index" v-show="index<5">
          <div class="li_top" :class="['li_top',{'color2':index==1},{'color3':index==2},{'color4':index==3},{'color5':index==4}]">
            <h1>{{item.productName}}</h1>
            <p v-if="item.price==0.01"><span>面议</span></p>
            <p v-else>¥<span>{{item.price}}</span>元/年</p>
            <p class="p_btn">
              <span @click="handleBuy(item,index)">{{item.price==0.01?'立即咨询':'立即购买'}}</span>
            </p>
          </div>
          <div class="li_bottom">
            <el-row>
              <el-col :span="12">用户数</el-col>
              <el-col :span="12" style="text-align:right;">{{item.price==0.01?'面议':item.staffTotal+'人'}}</el-col>
              <div class="clear"></div> 
            </el-row>
            <el-row>
              <el-col :span="12">免费存储空间</el-col>
              <el-col :span="12" style="text-align:right;">{{item.price==0?'面议':item.diskTotal+'GB'}}</el-col>
              <div class="clear"></div> 
            </el-row>
            <el-row>
              <el-col :span="12">适用行业</el-col>
              <el-col :span="12" style="text-align:right;">全行业</el-col>
              <div class="clear"></div> 
            </el-row>
            <el-row>
              <el-col :span="12">适用地区</el-col>
              <el-col :span="12" style="text-align:right;">全国</el-col>
              <div class="clear"></div> 
            </el-row>
          </div>
        </li>
      </ul>
    </div>
    <Footer></Footer>
  </section>
</template>
<script>
import Footer from '../components/common/footer'
import Header from '../components/common/header'
export default {
  name: 'home',
  components: { Footer, Header },
  data () {
    return {
      state:1,
      listData:[],
      numData:[50,150,500,1000,1000],
    }
  },
  created(){
    let that=this;
    this.$http.post('/api/product/list-product', {}).then(res=>{
      if(res.data.code=="OK"){
        that.listData=res.data.data;
      }else{
        that.$message({type: 'error',message: res.data.message})
      }
    })
  },
  methods:{
    handleBuy(item,index){//立即购买
      if(item.price==0.01){
        this.$message.success('请联系工作人员!')
      }else{
        this.$router.push({name: 'order', params: {setMealObj: item}});
        sessionStorage.setItem('setMealObj',JSON.stringify(item))
      }
    },
  }
}
</script>
<style lang="less" scoped>
h1,h4{
  margin: 0;
  padding: 0;
}
.clear{
  clear: both;
}
.content_wrap{
  padding: 0.1rem 0 1.1rem;
  h1{
    font-size:0.63rem;
    font-family:'PingFangSC-Medium','PingFang SC';
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:0.88rem;
    margin-bottom: 0.65rem;
  }
  .ul_meal{
    margin: 0 1.77rem;
    list-style: none;
    text-align: center;
    li{
      width: 18.5%;
      margin-right: 0.2rem;
      background:rgba(255,255,255,1);
      box-shadow:0 0.13rem 0.45rem 0 rgba(210,210,210,0.5);
      border-radius:0.09rem;
      display: inline-block;
      .li_top{
        width: 100%;
        height:3.3rem;
        color: #314E90;
        background:linear-gradient(180deg,rgba(205,221,255,1) 0%,rgba(189,205,255,1) 100%);
        border-radius:0.09rem 0.09rem 0 0;
        border: 0.01rem solid transparent;
        h1{
          text-align: center;
          margin: 0;
          padding: 0;
          font-size: 0.34rem;
          font-weight: 500;
          margin-top: 0.4rem;
          color: #314E90;
        }
        p{
          font-size: 0.17rem;
          margin: 0 0 0.3rem;
          span{
            font-size: 0.54rem;
            font-weight: 600;
            margin: 0 0.1rem;
          }
        }
        p.p_btn{
          text-align: center;
          margin: 0;
          span{
            width:2rem;
            height:0.46rem;
            line-height: 0.46rem;
            display: inline-block;
            font-size:0.16rem;
            font-weight: 500;
            background:rgba(255,255,255,0.5);
            border-radius:0.09rem;
            cursor: pointer;
          }
          span:hover{
            opacity: 0.6;
          }
        }
      }
      .li_top.color2{
        color: #2C42A2;
        background:linear-gradient(180deg,#A3C8FC 0%,#6DA2FE 100%);
        h1{
          color: #2C42A2;
        }
      }
      .li_top.color3{
        color: #6F4A12;
        background:linear-gradient(180deg,#FFEACE 0%,#FFDDB5 100%);
        h1{
          color: #6F4A12;
        }
      }
      .li_top.color4{
        color: #FECFBE;
        background:linear-gradient(180deg,#626CB1 0%,#353B5C 100%);
        h1{
          color: #FECFBE;
        }
        p.p_btn{
          span{
            background:rgba(124,127,200,1);
          }
        }
      }
      .li_top.color5{
        color: #EFC393;
        background:linear-gradient(180deg,#7772B6 0%,#5A5499 100%);
        h1{
          color: #EFC393;
        }
      }
      .li_bottom{
        padding: 0.3rem 0.18rem;
        .el-row{
          margin-bottom: 0.24rem;
          font-size:0.24rem;
          font-weight:500;
          color:rgba(102,102,102,1);
          line-height:0.5rem;
          text-align: left;
          .el-col:last-child{
            text-align: right;
          }
        }
        .el-row:last-child{
          margin-bottom: 0;
        }
      }
    }
    li:last-child{
      margin-right: 0;
    }
  }
}
@media screen and(min-width: 1680px) {
  h1,h4{
    margin: 0;
    padding: 0;
  }
  .content_wrap{
    padding: 10px 0 110px;
    height: 725px;
    h1{
      font-size:63px;
      font-family:'PingFangSC-Medium','PingFang SC';
      font-weight:500;
      color:rgba(51,51,51,1);
      line-height:88px;
      margin-bottom: 65px;
    }
    .ul_meal{
      padding: 0 80px;
      height: 610px;
      list-style: none;
      
      li{
        width: 18%;
        height: 100%;
        margin-right: 16px;
        background:rgba(255,255,255,1);
        box-shadow:0px 13px 45px 0px rgba(210,210,210,0.5);
        border-radius:9px;
        .li_top{
          width: 100%;
          height:329px !important;
          color: #314E90;
          background:linear-gradient(180deg,rgba(205,221,255,1) 0%,rgba(189,205,255,1) 100%);
          border-radius:9px 9px 0px 0px;
          border: 1px solid transparent;
          h1{
            text-align: center;
            margin: 0;
            padding: 0;
            font-size: 34px;
            font-weight: 500;
            margin-top: 40px;
            color: #314E90;
            line-height: 48px;
          }
          p{
            font-size: 17px;
            margin: 35px 0 0;
            span{
              font-size: 54px;
              font-weight: 600;
              margin: 0 10px;
            }
          }
          p.p_btn{
            text-align: center;
            margin: 0;
            margin: 35px 0 0;
            span{
              width:199px;
              height:46px;
              line-height: 46px;
              display: inline-block;
              font-size:16px;
              font-weight: 500;
              background:rgba(255,255,255,0.5);
              border-radius:9px;
              cursor: pointer;
            }
          }
        }
        .li_top.color2{
          color: #2C42A2;
          background:linear-gradient(180deg,#A3C8FC 0%,#6DA2FE 100%);
          h1{
            color: #2C42A2;
          }
        }
        .li_top.color3{
          color: #6F4A12;
          background:linear-gradient(180deg,#FFEACE 0%,#FFDDB5 100%);
          h1{
            color: #6F4A12;
          }
        }
        .li_top.color4{
          color: #FECFBE;
          background:linear-gradient(180deg,#626CB1 0%,#353B5C 100%);
          h1{
            color: #FECFBE;
          }
          p.p_btn{
            span{
              background:rgba(124,127,200,1);
            }
          }
        }
        .li_top.color5{
          color: #EFC393;
          background:linear-gradient(180deg,#7772B6 0%,#5A5499 100%);
          h1{
            color: #EFC393;
          }
        }
        .li_bottom{
          padding: 30px 18px;
          .el-row{
            margin-bottom: 24px;
            font-size:16px;
            font-weight:500;
            color:rgba(102,102,102,1);
            line-height:34px;
            text-align: left;
            .el-col:last-child{
              text-align: right;
            }
          }
          .el-row:last-child{
            margin-bottom: 0;
          }
        }
      }
      li:last-child{
        margin-right: 0 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/purchasePage.vue